import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_UPDATE_HALAL_STOCK_PRICE } from "../../../config/api";
import { getStock } from "./getStock";
import { getStockPriceHistory } from "./getStockPriceHistory";

export const updateStockPrice = createAsyncThunk(
  "stocks/updatePrice",
  async ({ id, data, callback }, { dispatch, rejectWithValue }) => {
    try {
      const response = await Client({
        method: "POST",
        path: API_UPDATE_HALAL_STOCK_PRICE(id),
        data: data,
      });
      toast.success("Stock price updated successfully");
      dispatch(getStock(id));
      dispatch(getStockPriceHistory(id));
      callback && callback();
      return response?.data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      return rejectWithValue(error.message);
    }
  }
);
